/*
* 自定义Footer
*/
import {
    Layout,
    theme,
} from 'antd';



const { Footer } = Layout;

const XFooter = () => {
    const {
        token: {
            colorPrimaryBg,
            colorPrimaryText,
        },
    } = theme.useToken();

    return (
        <Footer style={{
            textAlign: 'center',
            fontSize: 12,
            padding: '1px 0',
            background: colorPrimaryBg,
            color: colorPrimaryText,
        }}>
            Copyright @ 2023 湖南新致腾信息科技有限公司
        </Footer>
    );

}

export default XFooter